import { NgModule } from '@angular/core'
import { Routes, RouterModule, PreloadAllModules } from '@angular/router'
import { authGuard } from './core/core.module'
import { LogoutComponent } from './features/authentication/logout/logout.component'
import { profileCompleteGuard } from './core/profiling/profile-complete.guard'
import { CallbackComponent } from './features/callback/callback/callback.component'
import { adminGuard } from './core/auth/admin.guard'

const routes: Routes = [
  { path: '', redirectTo: 'organizations', pathMatch: 'full' },
  {
    path: 'login',
    loadChildren: () =>
      import('./features/authentication/authentication.module').then(
        (m) => m.AuthenticationModule
      )
  },
  { path: 'callback', component: CallbackComponent },
  {
    path: 'callback-error',
    loadChildren: () =>
      import('./features/callback-error/callback-error.module').then(
        (m) => m.CallbackErrorModule
      )
  },
  { path: 'logout', component: LogoutComponent },

  {
    path: 'signup',
    loadChildren: () =>
      import('./features/registration/registration.module').then(
        (m) => m.RegistrationModule
      )
  },
  {
    path: 'about',
    loadChildren: () =>
      import('./features/about/about.module').then((m) => m.AboutModule)
  },
  {
    path: 'feature-list',
    loadChildren: () =>
      import('./features/feature-list/feature-list.module').then(
        (m) => m.FeatureListModule
      )
  },
  /* {
    path: 'examples',
    loadChildren: () =>
      import('./features/examples/examples.module').then(
        (m) => m.ExamplesModule
      )
  },*/

  // Protected routes
  {
    path: 'organizations',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        canActivate: [profileCompleteGuard],
        loadChildren: () =>
          import('./features/organization/organization.module').then(
            (m) => m.OrganizationModule
          )
      }
    ]
  },
  {
    path: 'user-form',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./features/user-profile/user-profile.module').then(
        (m) => m.UserProfileModule
      )
  },
  {
    path: 'workspace-create',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./app/workspace-create/workspace-create-routing.module').then(
        (m) => m.WorkspaceCreateRoutingModule
      )
  },

  {
    path: 'settings',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./features/settings/settings.module').then(
        (m) => m.SettingsModule
      )
  },
  {
    path: 'portfolios',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        canActivate: [profileCompleteGuard],
        loadChildren: () =>
          import('./features/portfolio/portfolio.module').then(
            (m) => m.PortfolioModule
          )
      }
    ]
  },
  {
    path: 'admin',
    canActivate: [authGuard, adminGuard],
    loadChildren: () =>
      import('./features/admin/admin.module').then((m) => m.AdminModule)
  },
  {
    path: 'value-streams',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        canActivate: [profileCompleteGuard],
        loadChildren: () =>
          import('./features/value-stream/value-stream.module').then(
            (m) => m.ValueStreamModule
          )
      }
    ]
  },
  {
    path: 'solutions',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./features/solutions/solutions.module').then(
        (m) => m.SolutionsModule
      )
  },
  {
    path: 'teams',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        canActivate: [profileCompleteGuard],
        loadChildren: () =>
          import('./features/teams/teams.module').then((m) => m.TeamsModule)
      }
    ]
  },
  {
    path: 'requirements',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./features/requirements/requirements.module').then(
        (m) => m.RequirementsModule
      )
  },
  {
    path: 'program-increments',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        canActivate: [profileCompleteGuard],
        loadChildren: () =>
          import('./features/program-increment/program-increment.module').then(
            (m) => m.ProgramIncrementModule
          )
      }
    ]
  },
  {
    path: 'arts',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        canActivate: [profileCompleteGuard],
        loadChildren: () =>
          import('./features/arts/arts.module').then((m) => m.ARTSModule)
      }
    ]
  },
  {
    path: 'kanban',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./features/kanban-board/kanban-board.module').then(
        (m) => m.KanbanBoardModule
      )
  },
  {
    path: 'user',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./features/user/user.module').then((m) => m.UserModule)
  },

  { path: '**', redirectTo: 'login' }
]

@NgModule({
  // useHash supports github.io demo page, remove in your app
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      scrollPositionRestoration: 'enabled'
      // preloadingStrategy: PreloadAllModules
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
